export enum PermissionType {
  User = "User",
  Cave = "Cave",
}
